import { ReactComponent as DeleteIcon } from "assets/DeleteIcon.svg";
import { ReactComponent as EditIcon } from "assets/EditIcon.svg";
import { ReactComponent as Export } from "assets/Export.svg";
import { ReactComponent as Save } from "assets/icon_save.svg";
import { exportURLs } from "components/common/Export/ExportAPIEndpoints";
import { filterPage } from "components/common/Filters/FiltersHelper";
import Typography from "components/common/Typography";
import SearchAppBar from "components/common/searchBar";
import { isEmpty, uniqueId } from "lodash";
import { useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { corpViewTypes } from "utils/CommonConstants";
import { editList, fileExportHandler, formFilterRequestPayload } from "utils/CommonFunctions";
import { serviceTypes } from "utils/Types";
import { setCorpSearchText, setDialog } from "../CorpUser.Slice";
import { tabs } from "../CorpView/CorpViewHelper";
import { getmyListType } from "./MyLists";
import "./MyLists.scss";

interface Props {
  view: string;
  selectedListType: string;
  getInputDetails: (prop: string) => void;
}

const TableEdit = (props: Props) => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const tab = searchParams.get("tab");
  const { view, selectedListType, getInputDetails } = props;
  const noOfRows = useAppSelector((state) => state.app.tableHelperData?.noOfRows);
  const selectedList = useAppSelector((state) => state.CorpDashboard.myListsSelected.selectedList);
  const globalFiltersforPage = useAppSelector(
    (state) =>
      state.globalFilters[
        selectedListType === "default"
          ? filterPage.dashboardDisplay
          : selectedListType === "consultant"
          ? filterPage.consultantListDisplay
          : filterPage.listDisplay
      ]
  );
  const dynamicSelectFlag = globalFiltersforPage?.dynamicSelectAll;
  const filterRequestPayload =
    view === corpViewTypes.dashboard
      ? globalFiltersforPage?.isFilterApplied
        ? globalFiltersforPage?.modifiedFilter
        : globalFiltersforPage?.defaultFilter
      : (isEmpty(globalFiltersforPage?.modifiedFilter)
          ? globalFiltersforPage?.defaultFilter
          : globalFiltersforPage?.modifiedFilter) || [];
  const formattedFilterRequestPayload = formFilterRequestPayload(filterRequestPayload);
  const isPropertiesTabSelected = tab === tabs.properties;
  const searchText = useAppSelector((state) => state.CorpDashboard.searchText[view]);

  const getInputVal = (val: string) => {
    getInputDetails(val);
    dispatch(setCorpSearchText({ view: view, value: val }));
  };

  const getListActionItems = (view: string, selectedListType: string) => {
    const myListType = getmyListType(selectedListType, selectedList?.name);
    const downloadURL = isPropertiesTabSelected ? exportURLs.corp_properties : exportURLs.corp_plans;
    let data = {
      ...formattedFilterRequestPayload,
      view,
      ...dynamicSelectFlag,
      fetchTemplatePlans: tab === tabs.template_plans
    };
    data = view === corpViewTypes.myList ? { ...data, myListType, myListId: selectedList?.id } : { ...data };

    const type = view === corpViewTypes.dashboard ? corpViewTypes.dashboard : selectedListType;

    const options = [
      {
        label: "Save View as a List",
        icon: Save,
        action: () => dispatch(setDialog({ dialogName: "saveList", isOpen: true, data: selectedList })),
        isVisible: isPropertiesTabSelected && type === "dashboard"
      },
      {
        label: "Rename",
        icon: EditIcon,
        action: () => dispatch(setDialog({ dialogName: "renameList", isOpen: true, data: selectedList })),
        isVisible: type === "dynamic"
      },
      {
        label: "Edit",
        icon: EditIcon,
        action: () => {
          editList(selectedList, selectedListType === "consultant" ? "sc" : "static");
        },
        isVisible: type === "static" || type === "consultant"
      },
      {
        label: "Export",
        icon: Export,
        action: () => fileExportHandler(downloadURL, serviceTypes.userplan, data),
        isVisible: noOfRows
      },
      {
        label: "Delete",
        icon: DeleteIcon,
        action: () =>
          dispatch(
            setDialog({
              dialogName: type === "dynamic" || type === "static" ? "deleteList" : "deleteSCList",
              isOpen: true,
              data: selectedList,
              listType: type
            })
          ),
        isVisible: type === "dynamic" || type === "static" || type === "consultant"
      }
    ];

    return options.filter((item: any) => item.isVisible);
  };

  return (
    <div className="my-list-table-edit-component">
      <SearchAppBar
        value={searchText}
        getInputDetails={getInputVal}
        sx={{ border: `solid 1px ${tokens.Border.General.Tertiary}`, height: "44px" }}
        isPreDefinedNav={true}
      />
      <div className="my-list-table-edit-container">
        {getListActionItems(view, selectedListType)?.map((list: any) => {
          return (
            <Typography
              key={uniqueId(String(list.label))}
              onClick={() => list?.action()}
              sx={{ cursor: "pointer" }}
              className="my-list-table-edit-typography"
              variant="body2"
            >
              <list.icon /> {list.label}
            </Typography>
          );
        })}
      </div>
    </div>
  );
};
export default TableEdit;
